/* Motion for the Mochi sections. Two jobs:

   1. A shared reveal. Everything worth noticing rises a few pixels into place
      the first time it comes into view, staggered inside its own section.
   2. The decibel bars, which fill in sequence once the plot is on screen.

   Both are progressive enhancement in the strict sense: the hidden state is
   applied BY THIS SCRIPT, not by the markup. If the file never runs, or motion
   is reduced, or IntersectionObserver is missing, the page is simply finished.
   Anything already on screen at load is marked done rather than animated, so
   nothing above the fold flickers.

   Never write data-mo-rise into a template by hand. The attribute is this
   script's own bookkeeping: init() skips anything that already carries it, so
   a hand-written one hides the element and then prevents the reveal that would
   have brought it back. Add the selector to RISE instead. */
(function () {
  'use strict';
  if (window.__moMotion) return;
  window.__moMotion = true;

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var HAS_IO = 'IntersectionObserver' in window;

  var RISE = [
    '.mo-head',
    '.mo-hero__copy', '.mo-hero__media', '.mo-hero__buy',
    '.mo-sofa__grid > *',
    '.mo-plot', '.mo-key',
    '.mo-tools > .mo-tool', '.mo-specs > .mo-spec',
    '.mo-rules > .mo-ruleitem',
    '.mo-list__copy', '.mo-list__stack',
    '.mo-cards > .mo-card',
    '.mo-guarantee',
    '.mo-faq > *',
    '.mo-close',
    '.mo-marks > .mo-marks__i',
    '.mo-pair',
    '.mo-pieces > .mo-piece',
    '.mo-rev__top', '.mo-rev__empty',
    '.mo-mochi'
  ].join(',');

  var io = null;
  if (HAS_IO && !REDUCE) {
    io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (!entries[i].isIntersecting) continue;
        show(entries[i].target);
        io.unobserve(entries[i].target);
      }
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
  }

  function fillBars(plot) {
    var fills = plot.querySelectorAll('.mo-row__fill');
    for (var i = 0; i < fills.length; i++) {
      fills[i].style.setProperty('--d', (i * 90) + 'ms');
    }
    plot.classList.add('is-lit');
  }

  function show(el) {
    el.classList.add('is-in');
    if (el.classList.contains('mo-plot')) fillBars(el);
  }

  function done(el) {
    el.classList.add('is-in');
    if (el.classList.contains('mo-plot')) plotDone(el);
  }

  function plotDone(plot) {
    // No stagger, no delay: the bars are already at full width.
    plot.classList.add('is-lit');
  }

  // Reads first, writes second. Measuring every target before touching any of
  // them keeps the page to a single layout pass; interleaving the two forced a
  // fresh layout for every element and showed up as a long task on phones.
  function init() {
    var items = [];
    var secs = document.querySelectorAll('.mo-sec');
    for (var s = 0; s < secs.length; s++) {
      var targets = secs[s].querySelectorAll(RISE);
      for (var i = 0; i < targets.length; i++) {
        if (targets[i].hasAttribute('data-mo-rise')) continue;
        items.push({ el: targets[i], i: i, seen: true });
      }
    }
    if (!items.length) return;

    var k;
    if (REDUCE || !io) {
      for (k = 0; k < items.length; k++) {
        items[k].el.setAttribute('data-mo-rise', '');
        done(items[k].el);
      }
      return;
    }

    // Already on screen: mark it finished instead of hiding and re-showing it.
    var vh = window.innerHeight || 0;
    for (k = 0; k < items.length; k++) {
      var box = items[k].el.getBoundingClientRect();
      items[k].seen = box.top < vh * 0.92 && box.bottom > 0;
    }

    for (k = 0; k < items.length; k++) {
      var el = items[k].el;
      el.style.setProperty('--d', (Math.min(items[k].i, 5) * 70) + 'ms');
      el.setAttribute('data-mo-rise', '');
      if (items[k].seen) done(el);
      else io.observe(el);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();